/**
 * Pricing Body — the unlocked middle of a pricing plan.
 *
 * The plan sets `templateLock: 'all'` so its parts cannot be removed or
 * reordered. A lock is inherited by descendants, so without this block's own
 * `templateLock: false` the author would be unable to touch the feature list
 * either — the same reason ShowcaseSlide's halves carry one.
 */
import { __ } from '@wordpress/i18n';
import { registerBlockType } from '@wordpress/blocks';
import {
  useBlockProps,
  useInnerBlocksProps,
  InnerBlocks,
} from '@wordpress/block-editor';
import metadata from './block.json';
import { getBlockGapValue } from '../../utils/helpers';

const TEMPLATE = [
  [
    'brandy/icon-list',
    {},
    [
      ['brandy/icon-list-item', { text: __('First feature', 'brandy-blocks') }],
      ['brandy/icon-list-item', { text: __('Second feature', 'brandy-blocks') }],
      ['brandy/icon-list-item', { text: __('Third feature', 'brandy-blocks') }],
    ],
  ],
];

registerBlockType(metadata.name, {
  __experimentalLabel: () => __('Body', 'brandy-blocks'),

  edit: ({ attributes }) => {
    // Mirrors render.php: core serializes no blockGap for this block, and the
    // gapped column is opt-in so untouched cards keep their own margins.
    const gap = getBlockGapValue(attributes?.style?.spacing?.blockGap);

    const blockProps = useBlockProps({
      className: gap
        ? 'brandy-pricing-plan__body has-block-gap'
        : 'brandy-pricing-plan__body',
      style: gap ? { '--brandy-pricing-body-gap': gap } : undefined,
    });

    const innerBlocksProps = useInnerBlocksProps(blockProps, {
      template: TEMPLATE,
      // Undoes the parent's lock for this subtree only.
      templateLock: false,
    });

    return <div {...innerBlocksProps} />;
  },

  // Dynamic, but the inner blocks still have to persist.
  save: () => <InnerBlocks.Content />,
});
